
import { io } from "socket.io-client";

const SERVER_URL = import.meta.env.VITE_API_BASE_URL_2 || "http://localhost:3000";
// console.log(import.meta.env.VITE_API_URL,"(import.meta.env.VITE_API_URL");
// console.log("scoket is connecting first time");
console.log("MODE:", import.meta.env.MODE);
console.log("API:", import.meta.env.VITE_API_BASE_URL_2);
let socket = null;
console.log(socket,"socket.js value")
console.log("socket.js----------------------------------->")
export function connectSocket(information) {
  console.log(information,"console infomration")
  console.log(socket)
  if (!socket) {
    console.log("socket connetion of socket")
    socket = io(SERVER_URL, {
      withCredentials: true,
      transports: ["websocket"],
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
    });
  }
    if (!socket.connected) {
      console.log("socket is conneted",socket)
    socket.connect(); // manually connect
  }
  console.log(socket,"socket data")
  return socket;
}

export function getSocket() {

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
